import React from "react";
import { FaCheck } from "react-icons/fa";

const VerticalStepper = ({
  steps = [],
  activeStep = 1,
  onStepClick,
  noCursor = false,
}) => {
  return (
    <>
      <style>{`
        .vertical-stepper {
          width: 100%;
        }

        .vertical-step {
          display: flex;
          align-items: flex-start;
        }

        .vertical-step-left {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding-bottom: 10px;
        }

        .vertical-step-circle {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f1f3f5;
          color: #6c757d;
          transition: all 0.3s ease;
        }

        .vertical-step-circle.active {
          background: var(--rv-primary-color);
          color: #fff;
        }

        .vertical-step-circle.completed {
          background: #28a745;
          color: #fff;
        }

        .vertical-step-line.active {
          background: var(--rv-primary-color);
        }

        .vertical-step-line {
          width: 2px;
          min-height: 150px;
          background: #d6d6d6;
          margin-top: 6px;
        }

        .vertical-step-content {
          padding-left: 16px;
          text-align: center;
        }

        .vertical-step-title {
          font-size: 14px;
          font-weight: 600;
          margin-bottom: 4px;
          margin-top: 4px;
          color: #222;
        }

        .vertical-step-title.active {
          color: var(--rv-primary-color);
        }

        .vertical-step-desc {
          font-size: 13px;
          color: #8c8c8c;
        }
      `}</style>

      <div className="vertical-stepper">
        {steps.map((step, index) => {
          const stepNo = index + 1;

          const active = activeStep === stepNo;

          const completed = activeStep > stepNo;

          return (
            <div className="vertical-step" key={stepNo}>
              <div className="vertical-step-left">

                {/* CIRCLE */}
                <div
                  className={`vertical-step-circle ${
                    completed ? "completed" : active ? "active" : ""
                  }`}
                  style={{
                    cursor: noCursor ? "default" : "pointer",
                  }}
                  onClick={() =>
                    !noCursor && onStepClick?.(stepNo)
                  }
                >
                  {completed ? (
                    <FaCheck size={16} />
                  ) : step.icon ? (
                    <img
                      src={step.icon}
                      alt=""
                      style={{
                        width: 22,
                        height: 22,
                        objectFit: "contain",
                      }}
                    />
                  ) : (
                    stepNo
                  )}
                </div>

                {/* CONTENT */}
                <div
                  className="vertical-step-content"
                  style={{
                    cursor: noCursor ? "default" : "pointer",
                  }}
                  onClick={() =>
                    !noCursor && onStepClick?.(stepNo)
                  }
                >
                  <div
                    className={`vertical-step-title ${
                      active ? "active" : ""
                    }`}
                  >
                    {step.title}
                  </div>

                  <div className="vertical-step-desc">
                    {step.description}
                  </div>
                </div>

                {/* LINE */}
                {index !== steps.length - 1 && (
                  <div
                    className={`vertical-step-line ${
                      completed ? "active" : ""
                    }`}
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default VerticalStepper;